<div class="container">
  <h2 class="my-5">Book Your Trip</h2>

  <section class="col-md-8">
    <p>We've partnered with our local travel agencies to develop travel packages designed for some of our most common visitors.</p>
  </section>

  <hr class="my-5">

  <app-personas-booking />

  <hr class="my-5">

  <section class="col-md-10">
    <h3>Looking For Something More Personalized?</h3>

    <p>Give one of our local travel agencies a call to make travel arrangements that are tailored to your unique situation.</p>

    <div class="row my-5">
      <div class="col-md-4">
        <h5>Travel Agency 1</h5>
        <p>
          1234 Address Street<br>Yellow Leaf Bay, Taniti
        </p>
        <p>+12 928-555-1234</p>
      </div>

      <div class="col-md-4">
        <h5>Travel Agency 2</h5>
        <p>
          3241 Directions Way<br>Yellow Leaf Bay, Taniti
        </p>
        <p>+12 928-555-3241</p>
      </div>

      <div class="col-md-4">
        <h5>Travel Agency 3</h5>
        <p>
          4321 Location Avenue<br>Yellow Leaf Bay, Taniti
        </p>
        <p>+12 928-555-4321</p>
      </div>
    </div>
  </section>
</div>
